module.exports = __webpack_public_path__ + "static/media/development-recipes.cdbc8797.png";